import I from '@/components/I'
import {SUCCESS_CODE} from '@/constants'
import {GetServerSideProps} from 'next'
import {useEffect, useState, useRef, ReactEventHandler} from 'react'
//@ts-ignore
import {useLottie} from '@/hooks/useLottie'
import classNames from 'classnames'
import {useActivity} from '@/pages/activity/tenyears'
import {ActivityId, CombineImage_Map, IMAGE_MAP, TenAcTitle} from '@/constants/activityCdn'
import TitleBar from '@/components/TitleBar'
import {Toast} from 'gotu-ui'
import {DoMissionRes, FragmentModule, MainButton, SubActivityModule, combineCake, openReward} from '@/service/activity'
import {useGlobal, useUaParam} from '@/pages/_app'
import {openWindow, toLoginPage} from '@/plugins/bridge'
import Fragment from './fragment'
import OpenAppWrap from '@/components/OpenAppWrap'
import {parse} from 'cookie'
import {useCombine} from '@/pages/activity/tenyears/combine'
import Cake from './cake'
import {haboClickReport} from '@/plugins/habo'
const styles = require('./style.module.less')
interface ModuleProps {
  fragmentModule: FragmentModule,
  mainButton: MainButton,
  activityPhase: number,
  scrollModule: (type: 'main' | 'child') => void,
  combineRef: any,
}

const CakeBox = (props: ModuleProps) => {
    const {
        fragmentModule,
        mainButton,
        activityPhase,
        scrollModule,
        combineRef,
    } = props
    const {
        isApp,
        isLogin,
        fromId = 23001,
        source,
        p_client = '1',
    } = useUaParam()
    const appList:Record<string, AppName> = {
        1: 'gaotu',
        8: 'jingpin',
        6: 'gongkao',
        3: 'xinli',
    }
    const [openAppVisible, setOpenAppVisible] = useState(false)
    const {
        activeFraId,
        setActiveFraId,
        getData,
        data,
    } = useCombine()
    const cakeRef = useRef<HTMLDivElement>(null)
    const [rewardInfo, setRewardInfo] = useState<DoMissionRes | null>(null)
    // 移出屏幕动画触发
    const [leave, setLeave] = useState(false)
    const {refreshUaParam} = useGlobal()
    const schemeParams = {

    }
    useEffect(() => {
        //端外唤起app ，端内显示开奖
        if (!isApp && activityPhase === 2 && mainButton.status === 4) {
            setOpenAppVisible(true)
        } else {
            setOpenAppVisible(false)
        }
    }, [
        isApp,
        activityPhase,
        mainButton.status,
    ])
    const goUrl = (url: string) => {
        if (isApp) {
            openWindow(url, 'hide', 'hide')
        } else {
            window.open(url)
        }
    }
    const goRule = () => {
        const url = `${location.origin}/book-content/activity/tenyears/rule?fromId=${fromId}`
        goUrl(url)
    }
    const goPool = () => {
        haboClickReport('十周年奖池点击', {source, activity_id: ActivityId})
        const url = `${location.origin}/book-content/activity/tenyears/gift?fromId=${fromId}`
        goUrl(url)
    }
    const mainClick = async () => {
        haboClickReport('十周年蛋糕按钮点击', {source, btn_name: mainButton.text, activity_id: ActivityId})
        if (activityPhase === 1 && !isLogin) {
            //移动到子会场
            scrollModule('child')
            return
        }
        if (!isLogin || !data?.isLogin) {
            if (isApp) {
                toLoginPage(() => {
                    refreshUaParam()
                    getData()
                })
            } else {
                const backUrl = location.href
                const url = `${backUrl}${backUrl.indexOf('?') > -1 ? '&' : '?'}isLoginBack=1`
                location.href = `${location.origin}/login?redirect=${encodeURIComponent(url)}&forceBindMobile=1`
            }
            return
        }
        // 未集齐碎片，分会场移动到顶部
        if (mainButton.status === 2) {
            //开奖阶段
            if (activityPhase === 2) {
                Toast.show('下次早点参与活动哦~')
            } else {
                scrollModule('child')
            }
            return
        }
        if (mainButton.status === 3) {
            Toast.show('蛋糕合成成功！请等待7月6日10:00开奖')
            combineCake(fromId).then(() => {
                getData()
            })
            return
        }
        if (mainButton.status === 4 && activityPhase === 1) {
            Toast.show('还未到开奖时间哦')
            return
        }
        // 端外不能开奖，仅端内开奖
        if (mainButton.status === 4 && activityPhase === 2 && isApp) {
            const res = await openReward(fromId)
            const {code, data} = res
            if (code === 0) {
                getData()
                setLeave(true)
            }
            return
        }
        // 端外开奖阶段修改url参数 , 主要用于微信中携带参数到浏览起中
        if (mainButton.status === 4 && activityPhase === 2 && !isApp) {
            const cookies = parse(document.cookie)
            const url = new URL(window.location.href)
            const sid = cookies.sid
            sid && url.searchParams.set('sid', sid)
            window.history.pushState({}, '', url)
            return
        }
    }
    // 用户已开奖，直接展示最终奖品
    useEffect(() => {
        if (mainButton.status === 5) {
            setLeave(true)
            fragmentModule.rewardInfo && setRewardInfo(fragmentModule.rewardInfo)
        }
    }, [mainButton])

    const mainButtonBox = () => {
        // 未集齐碎片 且 处于开奖阶段 置灰
        const isGray = mainButton.status === 2 && activityPhase === 2
        return (
            <div
                className={classNames(styles.btn, leave && 'hide', isGray && styles.gray)}
                onClick={mainClick}
            >
                {mainButton.text}
                <I
                    className={styles.hand}
                    src={CombineImage_Map.btn_hand}
                    width={66}
                    height={66}
                ></I>
            </div>
        )
    }

    return (
        <div
            ref={cakeRef}
            className={classNames({[styles.cake]: true})}
        >
            <I
                className='w62% hauto'
                width={268}
                height={131}
                src={CombineImage_Map.combine_title}
            >
            </I>
            <div
                className={styles.intro}
                onClick={goPool}
            >
                <div className='center nowrap fc'>
                    集蛋糕分66w大奖 查看奖品
                    { '> '}
                </div>
            </div>
            <Fragment
                fragmentModule={fragmentModule}
                leave={leave}
                scrollModule={scrollModule}
                mainButton={mainButton}
                combineRef={combineRef}
            ></Fragment>
            <Cake
                leave={leave}
                rewardInfo={rewardInfo}
                fragmentModule={fragmentModule}
                winerList={data?.winnerList}
                mainButton={mainButton}
            ></Cake>
            <div className={styles['rule-box']}>
                <div
                    className={styles.rule}
                    onClick={goRule}
                >
                    规
                    <br/>
                    则
                </div>
                <div
                    className={styles.rule}
                    onClick={goPool}
                >
                    奖
                    <br/>
                    品
                    <br/>
                    明
                    <br/>
                    细
                </div>
            </div>
            {
                openAppVisible && (
                    <OpenAppWrap
                        appName={appList[p_client] || 'gaotu'}
                        schemeParams={schemeParams}
                        className='w100% f jcenter'
                    >
                        {mainButtonBox()}
                    </OpenAppWrap>
                )
            }
            {
                !openAppVisible && mainButtonBox()
            }
            {
                leave && (
                    <div className={styles.handbox}>
                        <I
                            className={styles['left-hand']}
                            src={CombineImage_Map.left_hand}
                            width={122}
                        ></I>
                        <I
                            className={styles['right-hand']}
                            src={CombineImage_Map.right_hand}
                            width={122}
                        ></I>
                    </div>
                )
            }
            <div className={styles['cake-bg']}>
                <I
                    className='w100% hauto'
                    src='https://i.gsxcdn.com/2443978467_etzvpk27.png'
                    width={375}
                ></I>
            </div>
        </div>
    )
}

export default CakeBox
